module.exports = __webpack_public_path__ + "img/MineralienKritisch.315f66a5.png";